export const EkycDataLivenessCheck = function (livenessConfig) {

    const params = {
        ...livenessConfig
    };

    const apiUrl = params.ekyc_endpoint;
    const filePath = params.file_path;

    delete params.ekyc_endpoint;
    delete params.file_path;

    const formObject = {
        ...params
    }

    const basicAuthToken = params.token;

    // Build the full URL for the fetch request dynamically
    const apiUrlEndpoint = `${apiUrl}/IslWebAPI/faces/pages/webapi.xhtml`;

    // console.log('apiUrl2', apiUrlEndpoint);

    console.log('EkycDataLivenessCheck', params);

    async function convertFileToBase64(url) {
        const response = await fetch(url);
        const blob = await response.blob();

        return new Promise((resolve, reject) => {

            const reader = new FileReader();
            reader.readAsDataURL(blob);
            // reader.onloadend = () => resolve(reader.result.split(",")[1]);
            reader.onload = () => resolve(reader.result.split(',')[1]);

            reader.onerror = error => reject(error);

        });

    }

    const promises = [];
    if (formObject.doFacematch === 'true' || formObject.doFacematch === true) {
        const filePromise = convertFileToBase64(filePath)
            .then(base64String => {
                formObject['captureID'] = base64String;
                return formObject;
            });
        promises.push(filePromise);
    }

    return new Promise((resolve, reject) => {

        Promise.all(promises)
            .then((aa) => {
                const jsonString = JSON.stringify(formObject);

                // Perform the fetch request
                fetch(apiUrlEndpoint, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Basic ${basicAuthToken}` // Include encrypted token in the header
                    },
                    body: jsonString,
                    credentials: 'include',
                    mode: 'cors',
                    redirect: 'follow', // Prevent auto-following of redirects

                })
                    .then(response => {
                        if (!response.ok) {
                            throw new Error('Network response was not ok');
                        }
                        return response.text(); // Get the response as HTML text
                    })
                    .then(html => {
                        console.log('livenes@html')
                        const res = {
                            html: html,
                            apiUrl: apiUrl,
                        };

                        resolve(res);
                        return res;
                    })
                    .catch((error) => {
                        console.error('Error:', error); // Log any errors to the console

                        reject({
                            step: 'liveness-check',
                            action: 'error',
                            message: 'عذراً، لا يمكنك استخدام هذه الخدمة في الوقت الحالي.',
                            error: error
                        });

                        return error;
                    });

            });

    })

}